import { ChartCard, type ChartCardState } from "../../ChartCard";
import { ToolCallsChart } from "../../ToolCallsChart";
import type { TenantToolCallHistory } from "../../../../hooks/useAdminStatus";

type ToolCallsPanelProps = {
  readonly status: "loading" | "ready" | "error";
  readonly history: TenantToolCallHistory | null;
  readonly error: string | null;
};

const cardState = (
  status: ToolCallsPanelProps["status"],
  history: TenantToolCallHistory | null,
): ChartCardState => {
  if (status === "loading") return "loading";
  if (status === "error") return "error";
  if (history == null || history.totalOk + history.totalError === 0) return "empty";
  return "ready";
};

export const ToolCallsPanel = ({ status, history, error }: ToolCallsPanelProps): JSX.Element => {
  const subtitle = history != null && history.totalOk + history.totalError > 0
    ? `${history.totalOk} ok · ${history.totalError} error`
    : undefined;
  return (
    <ChartCard
      title="Tool calls"
      subtitle={subtitle}
      state={cardState(status, history)}
      emptyText="No tool calls in this window."
      errorText={error ?? undefined}
    >
      {history != null && <ToolCallsChart history={history} />}
    </ChartCard>
  );
};
